// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCarrot = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M13 3.172V1h-2v2.172l-1-1-1.414 1.414.938.938C6.684 5.797 5.12 9.183 6.408 12.33l4.36 10.657h2.464l4.36-10.657c1.288-3.147-.277-6.533-3.116-7.806l.938-.938L14 2.172zM12 6c-2.873 0-4.83 2.913-3.741 5.573L9.252 14H12v2h-1.93L12 20.718l3.741-9.145q.117-.286.188-.573H13V9h2.908C15.456 7.323 13.936 6 12 6"
    />
  );
export default SvgIconCarrot;
